/* tslint:disable */

declare var Object: any;
export interface LerOperationTypeInterface {
  "id"?: number;
  "name"?: string;
}

export class LerOperationType implements LerOperationTypeInterface {
  "id": number;
  "name": string;
  constructor(data?: LerOperationTypeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LerOperationType`.
   */
  public static getModelName() {
    return "LerOperationType";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LerOperationType for dynamic purposes.
  **/
  public static factory(data: LerOperationTypeInterface): LerOperationType{
    return new LerOperationType(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'LerOperationType',
      plural: 'LerOperationTypes',
      path: 'LerOperationTypes',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/LerOperationType.ts